import GOTUtil from './GOTUtil';
import Warning from './Warn';
export default class UserFormUtil
{
	
	static findUserXMLNodeById(userXML,id)
	{
		let list = userXML.getElementsByTagName("node");
		for(let i = 0;i<list.length;i++)
		{
			let item = list[i];
			if(item.id == id)
				return item;
		}
		return null;
	}

	static findFormXMLNodeById(formXML,id)
	{
		let list = formXML.getElementsByTagName("node");
		for(let i = 0;i<list.length;i++)
		{
			let item = list[i];
			if(item.id == id)
				return item;
		}
		return null;
	}

	static mergeXML(userXML, formXML, formNodeList)
	{
		
		if(formNodeList==null)
			formNodeList = UserFormUtil.getFormNodeList(formXML);
		
		userXML = userXML.cloneNode(true);
		
		let i;
		let j;
		let userNodeList = UserFormUtil.getUserNodeList(userXML);
		delete userXML.nodeList;
		
		let isSame = true;
		if(userNodeList.length!=formNodeList.length)
		{
			isSame = false;
		}
		else
		{
			for(i=0; i<userNodeList.length; i++)
			{
				if(userNodeList[i]!=formNodeList[i])
				{
					isSame = false;
					break;
				}
			}
		}
		
		if(isSame)
			return userXML;
		

		var uList, uItem, uParent, uBrother;
		var fList, fItem, fParent, fBrother;
		
		fList = formNodeList;
		uList = userNodeList;

		
		//根据uList，到fList中找对应节点，如果找不到，则删除UserXML中相应的node
		//遍历之后，根据新的usrXML重新计算uList
		let uItemList;let uId;let fId;let isIn;let isChange = false;
		for(let i=0; i<uList.length; i++)
		{
			uId = uList[i];
			isIn = false;
			for(j=0; j<fList.length; j++)
			{
				fId = fList[j];
				if(fId==uId)
				{
					isIn = true;
					break;
				}
				else if(fId>uId)
				{
					break;
				}
			}
			
			if(isIn==false)
			{
				uItem = UserFormUtil.findUserXMLNodeById(userXML,uId);
				if(uItem)
				{
					uItem.parentNode.removeChild(uItem);
					//XMLHelper.deleteNode(uItem);
					isChange = true;
				}
			}
		}
		
		if(isChange)
		{
			uList = UserFormUtil.getUserNodeList(userXML);
		}
		
		
		//根据fList,到uList中找对应的节点，如果找不到，则在userXML中补充相应的节点
		let nnn = 0;
		while(uList.length<fList.length)
		{
			if(nnn>100000)
			{
				Warning.show({text:"之前保存的页面调整默认方案由于更新已完成失效 请于管理员联系"});
				return false;
			}
			nnn++;
			for(let i=0; i<fList.length; i++)
			{
				fId = fList[i];
				isIn = false;
				for(j=0; j<uList.length; j++)
				{
					uId = uList[j];
					if(uId==fId)
					{
						isIn = true;
						break;
					}
				}
				if(isIn==false)
				{
					fItem = GOTUtil.getFormItemInnerXMLByCache(formXML,fId);
					//fItem = formXML.FormDesign..FormItem.(@id==String(fId))[0];
					fParent = fItem.parentNode;
					let fChildIndex;
					for(let n = 0;n<fParent.children.length;n++)
					{
						if(fParent.children[n].id == fItem.id)
							fChildIndex = n;
					}
					var fParentId = fParent.id;
					var fLeftId;
					var fRightId;
					
					if(fChildIndex==1)	//原来应该是0  因为有Properties存在，所以1为第1个
					{
						fLeftId = "null";
					}
					else
					{
						fLeftId = fParent.children[fChildIndex-1].id;
					}
					
					if(fChildIndex==fParent.children.length-1)
					{
						fRightId = "null";
					}
					else
					{
						fRightId = fParent.children[fChildIndex+1].id;	
					}
					
					let newUItem = userXML.ownerDocument.createElement("node");
					newUItem.id = fId;
					
					uParent = null;
					if(fParentId=="")
					{
						uParent = userXML;
					}
					else 
					{
						uParent = UserFormUtil.findUserXMLNodeById(userXML,fParentId);
					}

					if(uParent)
					{
						if(fLeftId=="null")
						{
							uParent.insertBefore(newUItem,uParent.children[0]);
							//uParent.prependChild(newUItem);
							isChange = true;
						}
						else if(fRightId=="null")
						{
							uParent.appendChild(newUItem);
							isChange = true;
						}
						else
						{
							//var uLeftList:XMLList = uParent.node.(@id==fLeftId);
							var uLeft = UserFormUtil.findUserXMLNodeById(uParent,fLeftId);
							if(uLeft)
							{
								if(uLeft.nextSibling)
									uParent.insertBefore(newUItem,uLeft.nextSibling);
								else
									uParent.appendChild(newUItem);
								isChange = true;
							}
							else
							{
								var uRight = UserFormUtil.findUserXMLNodeById(uParent,fRightId);
								if(uRight)
								{
									uParent.insertBefore(newUItem,uRight);
									isChange = true;
								}
								else
								{
									isChange = false;
								}
							}
						}
					}
					else
					{
						isChange = false;
					}
					
					if(isChange==true)
					{
						uList.push(fId);
					}
					
				}
			}
		
		}
		
		//var toTime:Date = new Date();
		//GongqiAlert.show((toTime.milliseconds - fromTime.milliseconds).toString());
		
		//TODO_YL  自动拟合完成之后不提醒
		// Warning.show({text:"用户自定义画面与最新版本不一致，已自动拟合，请与管理员联系!!!"});
		
		return userXML;
		
		
	}
	
	static getUserNodeList(userXML)
	{
		let list = userXML.getElementsByTagName("node");
		let array = [];
		for(let i = 0;i<list.length;i++)
		{
			let child = list[i];
			array.push(child.id);
		}
		array.sort(function sortNumber(a,b){return a - b});
		return array;
		
	}
	
	static getFormNodeList(formXML)
	{
		let formDesign = formXML.children[2];
		let list = formDesign.getElementsByTagName("FormItem");
		
		let array = [];
		for(let i = 0;i<list.length;i++)
		{
			let child = list[i];
			array.push(child.id);
		}
		array.sort(function sortNumber(a,b){return a - b});
		//array.sort(Array.NUMERIC);
		return array;
		
	}
}



// WEBPACK FOOTER //
// ./src/utils/UserFormUtil.js